import { render, staticRenderFns } from "./UserManual.vue?vue&type=template&id=4d634f72&scoped=true"
import script from "./UserManual.vue?vue&type=script&lang=ts"
export * from "./UserManual.vue?vue&type=script&lang=ts"
import style0 from "./UserManual.vue?vue&type=style&index=0&id=4d634f72&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d634f72",
  null
  
)

export default component.exports